import type { UserProfile } from '@factoryfixinc/ats-interfaces';
import { InternalError } from './internal.error';

export class UserOptedOutOfMessagingError extends InternalError {
  constructor(userProfile: Pick<UserProfile, 'id' | 'nameFirst' | 'nameLast'>) {
    super('User opted out of messaging', { data: { userProfile } });
  }
}
